/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_1_MetaInputs */

const en_mk_start_1_meta = /** @type {(inputs: Mk_Start_1_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`± 2 minutes`)
};

const id_mk_start_1_meta = /** @type {(inputs: Mk_Start_1_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`± 2 menit`)
};

/**
* | output |
* | --- |
* | "± 2 minutes" |
*
* @param {Mk_Start_1_MetaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_1_meta = /** @type {((inputs?: Mk_Start_1_MetaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_1_MetaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_1_meta(inputs)
	return en_mk_start_1_meta(inputs)
});